import { PANEL_PALETTE } from "../assistant-panel.tokens";

/** Gaya tombol "Mulai bicara" (kapsul gradasi premium) & jarak strip suara di atas composer. */

/** Jarak vertikal strip suara ke pesan di atas & composer di bawah (px). */
export const VOICE_STRIP_GAP = 10;
/** Margin samping strip suara; sama dengan padding composer & daftar pesan. */
export const VOICE_STRIP_MX = "md";

export const VOICE_START_CLASS = "assistant-voice-start";
export const VOICE_START_FROM = "#2563eb";
export const VOICE_START_TO = "#7c3aed";
export const VOICE_START_TRANSITION_MS = 220;
export const VOICE_START_SHIMMER_MS = 4800;

const SCHEME_DARK = '[data-mantine-color-scheme="dark"]';

function motionCss(): string {
	const c = `.${VOICE_START_CLASS}`;
	return `
${c} { transition: box-shadow ${VOICE_START_TRANSITION_MS}ms ease, transform ${VOICE_START_TRANSITION_MS}ms ease, filter ${VOICE_START_TRANSITION_MS}ms ease; }
${c}:not(:disabled):hover { transform: translateY(-1px); }
${c}:not(:disabled):active { transform: translateY(0); }
${c}:not(:disabled)::after { animation: assistant-voice-shimmer ${VOICE_START_SHIMMER_MS}ms ease-in-out infinite; }
@keyframes assistant-voice-shimmer { 0%,60% { transform: translateX(-120%); } 100% { transform: translateX(120%); } }
@media (prefers-reduced-motion: reduce) {
${c}, ${c}::after { animation: none !important; transition: none !important; }
${c}:not(:disabled):hover, ${c}:not(:disabled):active { transform: none; }
}`;
}

/**
 * CSS tombol. `animate` = false (setelan animasiTransisi mati) membuang semua
 * transisi/animasi; saat true, `prefers-reduced-motion` tetap mematikannya.
 * Warna terang/gelap lewat atribut skema warna Mantine.
 */
export function voiceStartCss(animate: boolean): string {
	const c = `.${VOICE_START_CLASS}`;
	return `
${c} {
	--vs-surface: ${PANEL_PALETTE.light.stripBg}; --vs-tint-a: rgba(37,99,235,.08); --vs-tint-b: rgba(124,58,237,.12);
	--vs-text: #1e3a8a; --vs-sub: #475569; --vs-hover-glow: rgba(99,102,241,.38);
	position: relative; overflow: hidden; isolation: isolate; display: flex; align-items: center; gap: 10px;
	width: 100%; padding: 8px 14px 8px 8px; border-radius: 999px; border: 1px solid transparent; cursor: pointer; text-align: left;
	color: var(--vs-text); font: inherit;
	background:
		linear-gradient(135deg, var(--vs-tint-a), var(--vs-tint-b)) padding-box,
		linear-gradient(var(--vs-surface), var(--vs-surface)) padding-box,
		linear-gradient(135deg, ${VOICE_START_FROM}, ${VOICE_START_TO}) border-box;
}
${SCHEME_DARK} ${c} {
	--vs-surface: ${PANEL_PALETTE.dark.stripBg}; --vs-tint-a: rgba(37,99,235,.22); --vs-tint-b: rgba(124,58,237,.26);
	--vs-text: #e0e7ff; --vs-sub: #b4bfe6; --vs-hover-glow: rgba(129,140,248,.45);
}
${c}::after { content: ""; position: absolute; inset: 0; z-index: -1; pointer-events: none; background: linear-gradient(105deg, transparent 35%, rgba(255,255,255,.35) 50%, transparent 65%); transform: translateX(-120%); }
${c}:not(:disabled):hover, ${c}:focus-visible { box-shadow: 0 4px 20px var(--vs-hover-glow); }
${c}:focus-visible { outline: 2px solid ${VOICE_START_FROM}; outline-offset: 2px; }
${SCHEME_DARK} ${c}:focus-visible { outline-color: #a5b4fc; }
${c}:disabled { cursor: not-allowed; opacity: .55; filter: grayscale(.6); box-shadow: none; }
${c}:disabled::after { display: none; }
${c} [data-vs-badge] { flex: none; display: grid; place-items: center; width: 30px; height: 30px; border-radius: 50%; color: #fff; background: linear-gradient(135deg, ${VOICE_START_FROM}, ${VOICE_START_TO}); }
${c} [data-vs-sub] { color: var(--vs-sub); }${animate ? motionCss() : ""}
`;
}
